<foo-control-label [control]="control" [templateOptions]="templateOptions"></foo-control-label>

<mat-form-field appearance="fill" class="datetimepicker">

  <input [formControl]="control"
         [max]="maxDate"
         [min]="minDate"
         [placeholder]="templateOptions?.placeholder | translate"
         [ngxMatDatetimePicker]="datetimePicker"
         matInput
         dir="ltr"
         readonly
         class="input-calendar d-none">

  <input [value]="formattedDate"
         readonly
         [disabled]="templateOptions?.readonly"
         [placeholder]="templateOptions?.placeholder | translate"
         class="input-calendar custom-input-calendar"
         (click)="openPicker(datetimePicker)">

  <ng-container *ngIf="control?.value && clearable">
    <div (click)="clearInput()" class="custom-clear-input" matDatepickerToggleIcon><span class="ng-clear"></span></div>
  </ng-container>

  <mat-datepicker-toggle [for]="$any(datetimePicker)"
                         matSuffix
                         [class.toggleDisabled]="templateOptions?.readonly"
                         [disabled]="templateOptions?.readonly">
    <mat-icon matDatepickerToggleIcon>
      <span class="foo-icon" [class]="icon"></span>
    </mat-icon>
  </mat-datepicker-toggle>
  <ngx-mat-datetime-picker #datetimePicker [enableMeridian]="true" [showSeconds]="false" dir="ltr">
    <ngx-mat-datepicker-actions>
      <button ngxMatDatepickerCancel class="foo-btn-outline-secondary min-width-70 border-none hover-none">{{"general.cancel" | translate}}</button>
      <button ngxMatDatepickerApply class="foo-btn-primary min-width-70">{{"general.apply" | translate}}</button>
    </ngx-mat-datepicker-actions>
  </ngx-mat-datetime-picker>
</mat-form-field>

<foo-control-errors *ngIf="!templateOptions?.readonly && !templateOptions?.hideErrors"
                    [control]="control"
                    [errorMessages]="errors"></foo-control-errors>
